<template>
    <div class="box-shadow-inside box-background box-ssjc">
        <div class="box-title flex-between">
            <div class="box-title-text box-title-bg02">
                <p class="">客户行业统计</p>
            </div>
            <div class="box-title-right">
            </div>
        </div>
        <div id="echart02" class="chart02" :style="{height: '480px'}"></div>
    </div>
</template>

<script>

    import xhr from "../../../utils/xhr";

    export default {
        name: 'MonitorEchartsTwo',
        data() {
            return {
                nowDate: "",
                industryList: []
            }
        },
        computed: {

        },
        mounted() {
            this.getFinancingByIndustryList()
        },
        methods:{
            echart02(){
                const myChart = this.$echarts.init(document.getElementById('echart02'))
                const option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)',
                        textStyle:{
                            fontSize:24,
                            color:'#96dcff'
                        }
                    },
                    legend: {
                        orient: 'vertical',
                        right: 15,
                        top: 'center',
                        data: this.industryList.map(item=>item.fi__industry),
                        textStyle:{
                            fontSize:16,
                            color:'#96dcff'
                        },
                        // formatter: function(name){
                        //     return name.length>10?name.substr(0,10)+"...":name;
                        // }
                    },
                    series: [
                        {
                            name: '客户行业统计',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            center: ["25%", "50%"],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '24',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: this.industryList.map(item=>({
                                value: item.fi__counts,
                                name: item.fi__industry||'未分类'
                            }))
                        }
                    ]
                }
                myChart.setOption(option);
                tools.loopShowTooltip(myChart, option, {loopSeries: true, interval: 4000}); // 使用循环轮播插件

            },
            getFinancingByIndustryList: function () {
                xhr.getFinancingByIndustryList(0, ({data}) => {
                    this.industryList = (data.data||[]).filter(item=>item.fi__industry)
                    this.echart02()
                })
            }
        },
        components: {

        },
        props: {

        },
        beforeDestroy() {
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorEchartsTwo.vue